import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Kai Faust
 * id 56A31026-C5C6-45D5-A9D4-1C660357F430
 * name shape-square-plus
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shape-square-plus.svg
 * tags
 * - Shape 
 */
export const ShapeSquarePlusIcon = createSvgIcon(<><path d="M19,5H22V7H19V10H17V7H14V5H17V2H19V5M17,19V13H19V21H3V5H11V7H5V19H17Z" /></>, 'ShapeSquarePlusIcon');
export default ShapeSquarePlusIcon